import {createAction} from 'web-app/util/redux/famly-app-helpers';
import {type CheckIn} from 'web-app/react/entities/common/checkin';

import type * as Models from './models/extended-child-checkin';

const domain = 'CHILD_PICKUP';

interface CheckinPayload {
    pickupTime?: string;
    relationId?: string;
    goHomeWithChildId?: string;
}

export const {action: show} = createAction(`${domain}/SHOW`, (childId: string) => ({
    childId,
}));

export const {action: hide} = createAction(`${domain}/HIDE`, () => ({}));

export const {action: selectPickupPerson} = createAction(
    `${domain}/SELECT_PICKUP_PERSON`,
    (pickupRelationId: string) => ({pickupRelationId}),
);

export const {action: selectGoHomeWithChildId} = createAction(
    `${domain}/SELECT_GOING_HOME_WITH_CHILD_ID`,
    (goHomeWithChildId: string) => ({
        goHomeWithChildId,
    }),
);

export const {
    action: updateCheckin,
    success: updateCheckinSuccess,
    failed: updateCheckinFailed,
} = createAction(
    `${domain}/UPDATE_CHECKIN`,
    (checkin: CheckinPayload) => ({checkin}),
    (response: CheckIn) => ({response}),
);

export const {
    action: fetchExtendedCheckin,
    success: fetchExtendedCheckinSuccess,
    failed: fetchExtendedCheckinFailed,
} = createAction(
    `${domain}/FETCH_EXTENDED_CHECKIN`,
    (childId: string) => ({childId}),
    (response: Models.ExtendedChildCheckin) => ({response}),
);
